<template>
  <div class="plc-videoEmbed">
    <div class="plc-videoEmbed__container">
      <iframe
        :src="generateURL"
        width="560"
        height="315"
        frameborder="0"
        allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
        modestbranding="1"
        allowfullscreen
        class="plc-videoEmbed__iframe"
      />
      <div class="plc-videoEmbed__coverChannel" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'GlVideoEmbed',
  props: {
    url: {
      type: String,
      required: true,
    },
    noCookie: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    generateURL() {
      return (
        this.url.replace(
          /youtu.be|youtube.com(\/embed)?/,
          `www.youtube${this.noCookie ? '-nocookie' : ''}.com/embed`
        ) + (this.url.includes('?') ? '&rel=0' : '?rel=0')
      )
    },
  },
}
</script>

<style lang="scss" scoped>
.plc-videoEmbed {
  &__container {
    height: 0;
    padding-bottom: 56.25%;
    position: relative;
  }

  &__iframe {
    height: 100%;
    left: 0;
    position: absolute;
    top: 0;
    width: 100%;
  }

  &__coverChannel {
    height: 60px;
    position: relative;
    width: 70%;
  }
}
</style>
